import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Modal,
  Button,
  TextField,
  Checkbox,
  Divider,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { motion } from "framer-motion";
import { useSelector, useDispatch } from "react-redux";
import configServ from "../../../services/config";
import { setSelectedCoupons } from "../../../redux/reducers/Cart";
const MotionBox = motion(Box);

const ApplyCouponModal = ({ open, handleClose }) => {
  const dispatch = useDispatch(); // Initialize dispatch
  const { cartValue, cartNetAmount, selectedCoupons } = useSelector(
    (state) => state.cart
  );
  const { company_id,user_id } = useSelector((state) => state.GlobalVariables);

  const [availableCoupons, setAvailableCoupons] = useState([]);
  const [loadingCoupons, setLoadingCoupons] = useState(false);

  console.log("assignCartNetAmount", cartNetAmount);
  useEffect(() => {
    const fetchCoupons = async () => {
      if (!open) return;

      const product_ids = cartValue.map((item) => item.id);

      const payload = {
        company_id: company_id,
        product_ids,
        cart_total: cartNetAmount,
        customer_id:user_id,
      };

      try {
        setLoadingCoupons(true);
        const response = await configServ.getAvailableCoupons(payload);
        if (response?.status) {
          setAvailableCoupons(response.coupons);
        } else {
          setAvailableCoupons([]);
        }
      } catch (error) {
        console.error("Failed to fetch coupons", error);
        setAvailableCoupons([]);
      } finally {
        setLoadingCoupons(false);
      }
    };

    fetchCoupons();
  }, [company_id, cartValue, open]);

  const handleSelectCoupon = (coupon) => {
    if (selectedCoupons?.[0]?.code === coupon.code) {
      dispatch(setSelectedCoupons([]));
    } else {
      dispatch(setSelectedCoupons([coupon]));
    }
  };
  
  return (
    <Modal open={open} onClose={handleClose}>
      <MotionBox
        initial={{ opacity: 0, y: -100 }}
        animate={{ opacity: 1, y: 50 }}
        exit={{ opacity: 0, y: -100 }}
        transition={{ duration: 0.3 }}
        sx={{
          width: { xs: "90%", md: "500px" },
          bgcolor: "background.paper",
          borderRadius: 2,
          mx: "auto",
          mt: 10,
          p: 3,
          boxShadow: 24,
          position: "relative",
          maxHeight: "70vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={handleClose}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" fontWeight="bold" mb={2}>
          APPLY COUPON
        </Typography>

        {/* Enter Code - Optional */}
        <TextField
          fullWidth
          placeholder="Enter coupon code"
          variant="outlined"
          size="small"
          InputProps={{
            endAdornment: (
              <Button color="error" sx={{ fontWeight: "bold" }}>
                CHECK
              </Button>
            ),
          }}
        />

        <Divider sx={{ my: 2 }} />

        {/* Coupon List */}
        <Box sx={{ overflowY: "auto", flexGrow: 1, pr: 1 }}>
          {loadingCoupons ? (
            <Typography>Loading coupons...</Typography>
          ) : availableCoupons?.length === 0 ? (
            <Typography>No coupons available</Typography>
          ) : (
            availableCoupons.map((coupon) => (
              <Box
                key={coupon.id}
                border="1px solid #ccc"
                borderRadius={1}
                p={2}
                mb={2}
                display="flex"
                gap={2}
                alignItems="flex-start"
              >
                <Checkbox
                  checked={selectedCoupons?.[0]?.code === coupon.code}
                  onChange={() => handleSelectCoupon(coupon)}
                />
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {coupon.coupon_name} ({coupon.code})
                  </Typography>
                  <Typography
                    variant="body2"
                    fontWeight="bold"
                    color="success.main"
                  >
                    {coupon.discount_type === "percentage"
                      ? `Save ${parseFloat(coupon.discount_value)}%`
                      : `Save ₹${parseFloat(coupon.discount_value)}`}
                  </Typography>
                  <Typography variant="body2" mt={0.5}>
                    Minimum order: ₹
                    {parseFloat(coupon.min_order_amount).toFixed(2)}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Valid till: {new Date(coupon.valid_to).toLocaleDateString()}
                  </Typography>
                </Box>
              </Box>
            ))
          )}
        </Box>

        <Divider sx={{ mt: 2, mb: 1 }} />

        {/* Footer */}
        <Box
          mt={1}
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          <Button
            variant="contained"
            color="error"
            sx={{ px: 5 }}
            disabled={selectedCoupons?.length === 0}
            onClick={handleClose}
          >
            APPLY
          </Button>
        </Box>
      </MotionBox>
    </Modal>
  );
};

export default ApplyCouponModal;
